<template>
  <div class="layout layout-form">
    <div class="column">
      <h1 v-if="config.title" class="title">{{ $t(config.title, 'title') }}</h1>
      <h1 key="question">{{ $t(config.question, 'question') }}</h1>
    </div>
    <div class="column">
      <form ref="form" class="form">
        <div
          v-bind:key="field.name"
          v-for="(field, i) in config.fields"
          :class="errorClass(field.name)"
        >
          <label v-if="labelTypes.includes(field.type)" :for="field.name"
            >{{ $t(field.label, field.name + '.label')
            }}<span v-if="isRequired(field)">*</span></label
          >
          <input
            :tabindex="i"
            v-if="inputTypes.includes(field.type)"
            :name="field.name"
            :type="field.type"
            :placeholder="$t(field.placeholder, field.name + '.placeholder')"
            v-model="fields[field.name]"
          />

          <input
            v-if="field.type === 'number'"
            :name="field.name"
            :type="field.type"
            :placeholder="field.placeholder"
            v-model="fields[field.name]"
            :min="field.minimum"
            :max="field.maximum"
            :step="field.step"
          />

          <label class="checkbox" v-if="field.type == 'checkbox'">
            <input
              :name="field.name"
              :type="field.type"
              :placeholder="$t(field.placeholder, field.name + '.placeholder')"
              v-model="fields[field.name]"
            />
            <span
              >{{ $t(field.label, fields[field.name] + '.label')
              }}<span v-if="isRequired(field)">*</span></span
            >
          </label>
          <select
            :name="field.name"
            v-if="field.type === 'select'"
            v-model="fields[field.name]"
          >
            <option
              :key="field.name + '-placeholder'"
              :value="null"
              v-if="!field.skipChoose"
              >{{ $t(field.placeholder, field.name + '.placeholder') }}</option
            >
            <option
              :key="field.name + option.label + i.toString()"
              v-for="(option, i) in field.options"
              :value="option.value"
              >{{
                $t(option.label, field.name + '.options.' + option.label)
              }}</option
            >
          </select>
          <div v-if="field.type == 'radio'" class="field field-radio">
            <label v-for="(opt, i) in field.options" :key="`${opt.label}${i}`">
              <input
                type="radio"
                :name="field.name"
                :value="opt.value"
                v-model="fields[field.name]"
              />
              {{ opt.label }}
            </label>
          </div>
          <div
            class="field-errors"
            v-if="validations[field.name].errors.length > 0 && submitted"
          >
            <ul>
              <li
                :key="`error_${field.name}_${error}`"
                v-for="error in validations[field.name].errors"
              >
                <span>{{ $t(error, error, 'errors') }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="clearfix actions">
          <a :style="buttonStyle" class="button next" @click.prevent="save">{{
            $t(config.submitText, 'submitText') || $t('Submit', 'submitText')
          }}</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import Vue from 'vue';
import Validations from '../lib/Validations';
import TranslationMixin from '../lib/TranslationMixin';
export default {
  name: 'Form',
  props: ['config'],
  mixins: [TranslationMixin],
  data: function() {
    return {
      fields: {},
      validations: {},
      fieldCache: {},
      submitted: false,
      inputTypes: ['text'],
      labelTypes: ['text', 'select', 'checkbox', 'radio', 'number'],
    };
  },
  created() {
    for (let field of this.config.fields) {
      if (field.type === 'select' && field.skipChoose === true) {
        Vue.set(this.fields, field.name, field.options[0].value);
      } else if (field.type === 'checkbox') {
        Vue.set(this.fields, field.name, false);
      } else if (field.type === 'number') {
        let fieldMessage = 'Must be a number';
        if (
          typeof field.minimum !== 'undefined' &&
          typeof field.maximum !== 'undefined'
        ) {
          fieldMessage += ` between ${field.minimum} and ${field.maximum}`;
        } else if (typeof field.minimum !== 'undefined') {
          fieldMessage += ` greater than or equal to ${field.minimum}`;
        } else if (typeof field.maximum !== 'undefined') {
          fieldMessage += ` less than or equal to ${field.maximum}`;
        }

        field.validations.push({
          type: 'numeric',
          message: fieldMessage,
          params: {
            minimum: parseFloat(field.minimum),
            maximum: parseFloat(field.maximum),
          },
        });
      } else {
        Vue.set(this.fields, field.name, '');
      }
      Vue.set(this.validations, field.name, {
        rules: field.validations,
        errors: [],
        dirty: false,
      });
    }
  },
  mounted() {
    // Vue.nextTick(() => {
    //   this.sub = true
    // })
  },
  methods: {
    isRequired(field) {
      let validationMethods = field.validations.map(validation => {
        return validation.type;
      });
      return validationMethods.indexOf('required') !== -1;
    },
    addBackgroundImage() {
      return Object.assign(
        {},
        { backgroundImage: 'url(' + this.config.background + ')' }
      );
    },
    errorClass(fieldName) {
      let classes = ['field'];
      classes.push(
        this.validations[fieldName].errors.length > 0 ? 'invalid' : 'valid'
      );
      return classes.join(' ');
    },
    save() {
      this.submitted = true;
      let valid = this.validate();
      if (!valid) {
        return;
      }
      this.$store.dispatch('saveAll', this.fields);
      this.$emit('answer');

      if (typeof this.config.next !== 'undefined') {
        this.$store.commit('setIndex', this.getNext(this.config.next));
      } else {
        this.$store.commit('advance');
      }
    },
    validate() {
      let valid = true;
      for (let field in this.validations) {
        this.validations[field].errors = [];
        for (let rule of this.validations[field].rules) {
          let input = this.fields[field];
          let params = typeof rule.params !== 'undefined' ? rule.params : null;
          let validField = Validations[rule.type](input, params);
          if (!validField) {
            this.validations[field].errors.push(rule.message);
            valid = false;
          }
        }
      }
      return valid;
    },
    mounted() {
      window.scroll(0, 0);
    },
  },
  inject: ['theme'],
  computed: {
    buttonStyle() {
      let style = Object.assign(this.theme.accent, {
        borderRadius: this.theme.borderRadius + 'px',
      });
      return style;
    },
  },
  watch: {
    fields: {
      handler: function(newValue) {
        for (let fieldName in newValue) {
          let field = this.fields[fieldName];
          if (field !== this.fieldCache[fieldName]) {
            this.validations[fieldName].dirty = true;
          }
        }
        this.fieldCache = Object.assign({}, newValue);
        if (this.submitted) {
          this.validate();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/base';

label.checkbox {
  display: block;
}

select {
  width: 100%;
}

a.next {
  @include button;
  text-transform: uppercase;
  display: block;
  text-align: center;
  padding: 0.75em;
}
</style>
